export const NEW_TEMPLATE_NAME = "Add a template";
export const NEW_TEMPLATE_ID = "new";
export const SENT_COMPONENT_TIMEOUT = 2000;
export const TEMPLATE_BODY_PLACEHOLDER = "Enter your email content here.";
